/*
 * File: index.tsx
 * Desc: 自定义弹窗工具
 * File Created: 2019-09-10 18:10:42
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import ReactDom from 'react-dom';

/** 自定义弹窗工具 */
export default class ModalCustom {
    /** 弹层DOM的id属性值 */
    private modalId: string;
    /** 弹层的DOM元素 */
    private modalEle: HTMLElement | null = null;

    constructor(modalId: string = 'react-admin_modal') {
        this.modalId = modalId;
        this.initDom();
    }

    initDom() {
        this.modalEle = document.getElementById(this.modalId);
        if (!this.modalEle) {
            this.modalEle = document.createElement('div');
            this.modalEle.setAttribute('id', 'react-admin_modal-' + Math.random());
            document.body.appendChild(this.modalEle);
        }
    }

    /** 显示 */
    show(component: React.ReactElement) {
        if (!this.modalEle) this.initDom();
        ReactDom.render(component, this.modalEle);
    }

    /** 销毁 */
    destroy() {
        if (this.modalEle) {
            ReactDom.unmountComponentAtNode(this.modalEle);
            this.modalEle.parentNode!.removeChild(this.modalEle);
            this.modalEle = null;
        }
    }
}
